export const state = () => ({
    isLoading: false,
    searchPhrase: ''
});

export const getters = {
    isLoading: state => state.isLoading,
    searchPhrase: state => state.searchPhrase
};

export const mutations = {
    UPDATE_SEARCH_PHRASE(state, { searchPhrase }) {
        state.searchPhrase = searchPhrase
    },

    UPDATE_LOADING_STATUS(state, { status }) {
        state.isLoading = status
    }
};

export const actions = {
    setSearchPhrase(vuexContext, searchPhrase) {
        vuexContext.commit('UPDATE_SEARCH_PHRASE', { searchPhrase: searchPhrase });
    },

    setLoading(vuexContext, status) {
        vuexContext.commit('UPDATE_LOADING_STATUS', { status: status });
    },
};
